/* global GM_STATE */
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { useEffect, useState, useRef } from 'preact/hooks'
import { getCartProperties, getDisableChangeQuantity, getLineItemRrp, getMaxQuantity, removeCartItem, updateCart, updateCartItem } from 'libs/cart'

function useCartItem(item, setCart, setIsFetching) {
  const [quantity, setQuantity] = useState(item.quantity)
  const [renderKey, setRenderKey] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const itemRef = useRef(item)
  const maxQuantity = getMaxQuantity(item)
  const properties = getCartProperties(item.properties)
  const isDisabled = getDisableChangeQuantity(properties)
  const originalLinePrice = getLineItemRrp(item)

  useEffect(() => {
    itemRef.current = item
  }, [item])

  useEffect(() => {
    const handleCartUpdate = (cartItems) => {
      if (!cartItems || !Array.isArray(cartItems)) return
      const currentItem = itemRef.current
      if (!currentItem || !currentItem.variant_id) return
      const updatedItem = cartItems.find(i => i.variant_id === currentItem.variant_id)
      if (updatedItem && updatedItem.key && updatedItem.key !== currentItem.key) {
        itemRef.current = updatedItem
      }
    }

    globalEmitter.on(emitterProps.cart.update, handleCartUpdate)
  }, [])

  const onLoading = (value) => {
    setIsFetching(value)
    setIsLoading(value)
  }

  const refreshCart = async () => {
    const newCart = await updateCart()
    setCart(newCart)
    GM_STATE.cart.initCart = newCart
    globalEmitter.emit(emitterProps.cart.update, newCart.items)
  }

  const onRemove = async () => {
    onLoading(true)
    try {
      await removeCartItem(itemRef.current.key)
      await refreshCart()
    } catch (error) {
      setRenderKey(renderKey + 1)
    }
    onLoading(false)
  }

  const onChange = async () => {
    onLoading(true)
    try {
      await updateCartItem(itemRef.current.key, quantity)
      await refreshCart()
    } catch (error) {
      setRenderKey(renderKey + 1)
    }
    onLoading(false)
  }

  const customClassPrice = (() => {
    let classSize = 'text-base'
    if (originalLinePrice > item.line_price) {
      const newClassSize = ' text-grey-300'
      classSize += newClassSize
    } else {
      classSize += ' text-grey-700'
    }
    return classSize
  })()

  useEffect(() => {
    setQuantity(item.quantity)
  }, [item])

  useEffect(() => {
    if (item.quantity !== quantity && quantity <= maxQuantity) {
      onChange(quantity)
    }
  }, [quantity])

  return {
    quantity,
    setQuantity,
    isLoading,
    setIsLoading,
    maxQuantity,
    properties,
    isDisabled,
    originalLinePrice,
    renderKey,
    onRemove,
    onChange,
    customClassPrice
  }
}

export default useCartItem
